export default __webpack_public_path__ + "2251a9b4c2c3479bc8fc1e57a706dbb6.babylon";